
import React, { useState } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import FeaturedPrograms from '../components/FeaturedPrograms';
import WhyChooseUs from '../components/WhyChooseUs';
import RealWorldLearning from '../components/RealWorldLearning';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import ContactPopup from '../components/ContactPopup';

const Index = () => {
  const [popupState, setPopupState] = useState({
    isOpen: false,
    title: "Get in Touch",
    subtitle: "Connect with our admissions team to learn more about our programs",
    formType: "popup_inquiry",
    interestedProgram: ""
  });

  const openPopup = (config: {
    title?: string;
    subtitle?: string;
    formType?: string;
    interestedProgram?: string;
  } = {}) => {
    setPopupState({
      isOpen: true,
      title: config.title || "Get in Touch",
      subtitle: config.subtitle || "Connect with our admissions team to learn more about our programs",
      formType: config.formType || "popup_inquiry",
      interestedProgram: config.interestedProgram || ""
    });
  };

  const closePopup = () => {
    setPopupState(prev => ({ ...prev, isOpen: false }));
  };

  return (
    <div className="min-h-screen bg-white">
      <Header openPopup={openPopup} />
      <HeroSection openPopup={openPopup} />
      <FeaturedPrograms openPopup={openPopup} />
      <WhyChooseUs />
      <RealWorldLearning />
      <FAQ />
      <Footer />
      
      <ContactPopup
        isOpen={popupState.isOpen}
        onClose={closePopup}
        title={popupState.title}
        subtitle={popupState.subtitle}
        formType={popupState.formType}
        interestedProgram={popupState.interestedProgram}
      />
    </div>
  );
};

export default Index;
